import React, { useEffect } from "react";
import NewHeader from "../../directives/NewHeader";
import { Col, Container, Row } from "react-bootstrap";
import "../../Styles/NewTestimonials.css";
import Footer from "../../directives/footer";
import { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import DownloadSection from "./DownloadSection";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const NewTestimonials = () => {
  const videoRef1 = useRef(null);
  const videoRef2 = useRef(null);
  const videoRef3 = useRef(null);
  const videoRef4 = useRef(null);
  const videoRef5 = useRef(null);
  const videoRef6 = useRef(null);
  const videoRef7 = useRef(null);
  const videoRef8 = useRef(null);
  const videoRef9 = useRef(null);

  const [isPlaying1, setIsPlaying1] = useState(false);
  const [isPlaying2, setIsPlaying2] = useState(false);
  const [isPlaying3, setIsPlaying3] = useState(false);
  const [isPlaying4, setIsPlaying4] = useState(false);
  const [isPlaying5, setIsPlaying5] = useState(false);
  const [isPlaying6, setIsPlaying6] = useState(false);
  const [isPlaying7, setIsPlaying7] = useState(false);
  const [isPlaying8, setIsPlaying8] = useState(false);
  const [isPlaying9, setIsPlaying9] = useState(false);

    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const swiperRef = useRef(null);
    const prevRef2 = useRef(null);
    const nextRef2 = useRef(null);
    const swiperRef2 = useRef(null);
  
    useEffect(() => {
      if (swiperRef.current && swiperRef.current.params) {
        swiperRef.current.params.navigation.prevEl = prevRef.current;
        swiperRef.current.params.navigation.nextEl = nextRef.current;
  
        // Re-init navigation
        swiperRef.current.navigation.destroy();
        swiperRef.current.navigation.init();
        swiperRef.current.navigation.update();
      }
      if (swiperRef2.current && swiperRef2.current.params) {
        swiperRef2.current.params.navigation.prevEl = prevRef2.current;
        swiperRef2.current.params.navigation.nextEl = nextRef2.current;
  
        // Re-init navigation
        swiperRef2.current.navigation.destroy();
        swiperRef2.current.navigation.init();
        swiperRef2.current.navigation.update();
      }
    }, []);

  const togglePlay = (currentRef, setCurrentPlaying, currentPlaying, otherRefs) => {
    // Pause all other videos
    otherRefs.forEach(({ ref, setPlaying }) => {
      if (ref.current && !ref.current.paused) {
        ref.current.pause();
        setPlaying(false);
      }
    });
  
    // Toggle current video
    if (currentRef.current.paused) {
      currentRef.current.play();
      setCurrentPlaying(true);
    } else {
      currentRef.current.pause();
      setCurrentPlaying(false);
    }
  };

  return (
    <>
      <div className="position-fixed w-100 " style={{ zIndex: 999 }}>
        <NewHeader />
      </div>
      <div className="top-shelf-start"></div>
      <div className="position-relative">
        <div className="cp1"></div>
        <div className="cp2"></div>
        <div className="cp3"></div>
        <div className="cp4"></div>
        <div className="cp5"></div>
        <div className="cp6"></div>
        <div className="cp7"></div>
        <div className="cp8"></div>

        <div className="new-home-section4 mt-5 ">
          <h4 className="new-testimonial-backheader">TESTIMONIAL</h4>
          <p className="new-testimonial-header">REAL TRANSFORMATION</p>
        </div>
        <p className=" text-center  w-100 mt-3">
          See how StepMint has empowered people to move, earn, and transform
          their lives.
        </p>

        {/* <Container className='py-5'>
    <div>
        <h2 className="custom-new-header">What Our <br />
        <span className="custom-new-text">Stepmint User</span> say</h2>
    </div>
  <div className="swiper-container">
          <button className="swiper-button-prev"></button>
          <button className="swiper-button-next"></button>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: { slidesPerView: 1 },  // Small screens
              640: { slidesPerView: 2 },  // Tablets
              1024: { slidesPerView: 3 }, // Desktops
              1440: { slidesPerView: 3 }, // Larger screens
            }}
            modules={[Navigation, Pagination]}
            className="mySwiper"
          >
              <SwiperSlide>
             
    <div className='new-home-testimonial text-white m-2
    px-4 py-3'>
       
       <div className='d-flex align-items-center gap-2 mb-3 pt-3'>
        <img src="assets\images\face1.png" alt="" style={{borderRadius:10, height:80, width:80}} />
        <h4 className='mb-0'>Harnam Singh</h4>
       </div>
       <p className=''>Stepmint has turned my daily steps into a dual-purpose mission—staying healthy and earning rewards. The more I walk, the better I feel, and the smarter I save. I enjoyed it. </p>
       <div className='d-flex mb-2 w-100 justify-content-between align-items-center'>
        <div >
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        </div>
        <small>15 November</small>
       </div>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div className='new-home-testimonial text-white m-2
    px-4 py-3'>
       
       <div className='d-flex align-items-center gap-2 mb-3 pt-3'>
        <img src="assets\images\face2.png" alt="" style={{borderRadius:10, height:80, width:80}} />
        <h4 className='mb-0'>Ajay Minocha</h4>
       </div>
       <p>Earlier, walking was just exercise. Now, with Stepmint, every step feels like an investment. It’s the perfect nudge I needed to stay active, and seeing those steps turn into digital assets? Pure motivation! </p>
       <div className='d-flex mb-2 w-100 justify-content-between align-items-center'>
        <div >
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        </div>
        <small>15 November</small>
       </div>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div className='new-home-testimonial text-white m-2
    px-4 py-3'>
       
       <div className='d-flex align-items-center gap-2 mb-3 pt-3'>
        <img src="assets\images\face3.png" alt="" style={{borderRadius:10, height:80, width:80}} />
        <h4 className='mb-0'>Yogesh Vastrakar</h4>
       </div>
       <p>Stepmint helped me break the cycle of procrastination. Now, I step out daily not just for health, but with a purpose. I’m building habits, earning rewards, and shaping a healthier, wealthier future.</p>
       <div className='d-flex mb-2 w-100 justify-content-between align-items-center'>
        <div >
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        </div>
        <small>15 November</small>
       </div>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div className='new-home-testimonial text-white m-2
    px-4 py-3'>
       
       <div className='d-flex align-items-center gap-2 mb-3 pt-3'>
        <img src="assets\images\face4.png" alt="" style={{borderRadius:10, height:80, width:80}} />
        <h4 className='mb-0'>Rajesh Pratap Singh</h4>
       </div>
       <p>With Stepmint, I don’t need to choose between my physical goals and financial ones. I’ve become more conscious of my lifestyle, and watching it translate into tangible digital benefits is just amazing.</p>
       <div className='d-flex mb-2 w-100 justify-content-between align-items-center'>
        <div >
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        <img src="assets\images\newdesign\star.svg" alt="" />
        </div>
        <small>15 November</small>
       </div>
    </div>
      </SwiperSlide>
          </Swiper>
        </div>
  </Container> */}

        <Container>
          <div className="text-center">
            <p className="new-testimonial-header">
              Featured <span className="new-testimonial-header2">Stories</span>
            </p>
          </div>
          <Swiper
            onSwiper={(swiper) => (swiperRef2.current = swiper)}
            slidesPerView={3}
            spaceBetween={30}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: { slidesPerView: 1 }, // Small screens
              768: { slidesPerView: 1 }, // Tablets
              1024: { slidesPerView: 2 }, // Desktops
              1440: { slidesPerView: 3 }, // Larger screens
              1880: { slidesPerView: 3 },
            }}
            modules={[Navigation, Pagination]}
            className="mySwiper align-items-stretch h-auto"
          >
            <SwiperSlide>
              <div className="new-testimonial-maindiv my-3">
                <div className="new-testimonial-div pt-5">
                  <div className="px-4">
                    <h4 className="mb-0 new-testimonial-per-head" style={{ fontWeight: 800 }}>
                      "It’s not just steps—it’s self-respect."
                    </h4>
                    <p className="new-testimonial-comment mt-3">
                      Walking daily seemed small, but with Stepmint, it feels
                      powerful. I’m honoring my body and, in return, gaining
                      financial strength. That’s the kind of motivation I
                      needed!
                    </p>
                  </div>
                  <br />
                  <br />
                  <div style={{ width: 100, height: 100 }}>
                    <img
                      src="assets\images\face1.png"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 250,
                      }}
                      alt=""
                    />
                  </div>
                  <div className="new-testimonial-div2">
                    <h6 className="mb-0">Harnam Singh</h6>
                    <small>Kurukshetra</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-testimonial-maindiv my-3">
                <div className="new-testimonial-div pt-5">
                  <div className="px-4">
                    <h4 className="mb-0 new-testimonial-per-head" style={{ fontWeight: 800 }}>
                      "Stepmint made fitness a financial asset."
                    </h4>
                    <p className="new-testimonial-comment mt-3">
                      We spend so much trying to get fit—gym fees, diets,
                      gadgets. Stepmint flipped the script. Now, fitness pays me
                      back. This is innovation with heart. Great Project.
                    </p>
                  </div>
                  <br />
                  <br />
                  <div style={{ width: 100, height: 100 }}>
                    <img
                      src="assets\images\face2.png"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 250,
                      }}
                      alt=""
                    />
                  </div>
                  <div className="new-testimonial-div2">
                    <h6 className="mb-0">Ajay Minocha</h6>
                    <small>Hyderabad</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-testimonial-maindiv my-3">
                <div className="new-testimonial-div pt-5">
                  <div className="px-4">
                    <h4 className="mb-0 new-testimonial-per-head" style={{ fontWeight: 800 }}>
                    "From tired steps to inspired steps!"
                    </h4>
                    <p className="new-testimonial-comment mt-3">
                      This app turned something ordinary into something
                      life-changing. I never thought I’d feel so motivated by
                      steps—but here I am, healthier and wealthier with every
                      move.
                    </p>
                  </div>
                  <br />
                  <br />
                  <div style={{ width: 100, height: 100 }}>
                    <img
                      src="assets\images\face4.png"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 250,
                      }}
                      alt=""
                    />
                  </div>
                  <div className="new-testimonial-div2">
                    <h6 className="mb-0">Rajesh Pratap Singh</h6>
                    <small>Indore</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="new-testimonial-maindiv my-3">
                <div className="new-testimonial-div pt-5">
                  <div className="px-4">
                    <h4
                      className="mb-0 new-testimonial-per-head"
                      style={{ fontWeight: 800, fontStyle: "italic" }}
                    >
                      "I gift myself better health. Stepmint adds a bonus."
                    </h4>
                    <p className="new-testimonial-comment mt-3">
                      Staying fit used to feel thankless. Now, every step is
                      acknowledged, appreciated, and rewarded. I feel seen. I
                      feel encouraged. I feel unstoppable.
                    </p>
                  </div>
                  <br />
                  <br />
                  <div style={{ width: 100, height: 100 }}>
                    <img
                      src="assets\images\face3.png"
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 250,
                      }}
                      alt=""
                    />
                  </div>
                  <div className="new-testimonial-div2">
                    <h6 className="mb-0">Yogesh Vastrakar</h6>
                    <small>Bilaspur</small>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
         
          <div className="d-flex gap-3 mt-3 justify-content-end align-items-center">
                    <button ref={prevRef2} className="custom-swiper-button-prev">
                      <FaChevronLeft style={{ color: "white" }} />
                    </button>
          
                    <button ref={nextRef2} className="custom-swiper-button-next">
                      <FaChevronRight style={{ color: "white" }} />
                    </button>
                  </div>

          <br />
          <br />
          <div className="new-home-section4 mt-5 mb-5 ">
            <h4 className="new-testimonial-backheader">COMMUNITY</h4>
            <p className="new-testimonial-header">Hear it from the Community</p>
          </div>
        </Container>

      

        <Container>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            navigation={{
              nextEl: ".custom-swiper-button-next",
              prevEl: ".custom-swiper-button-prev",
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: { slidesPerView: 1 }, // Small screens
              640: { slidesPerView: 2 }, // Tablets
              1024: { slidesPerView: 4 }, // Desktops
              1440: { slidesPerView: 4 }, // Larger screens
            }}
            
            modules={[Navigation, Pagination]}
            className="mySwiper align-items-stretch h-auto"
          >
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef1}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Rubi+sharma+final+mp4.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef1,
                      setIsPlaying1,
                      isPlaying1,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                      ]
                    )
                  }
                >
                  {isPlaying1 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef2}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Sagar.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef2,
                      setIsPlaying2,
                      isPlaying2,
                      [
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                      ]
                    )
                  }
                >
                  {isPlaying2 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef3}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Shamsher+Ansari.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef3,
                      setIsPlaying3,
                      isPlaying3,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                      ]
                    )
                  }
                >
                  {isPlaying3 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef4}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Hardip+Singh.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef4,
                      setIsPlaying4,
                      isPlaying4,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                      ]
                    )
                  }
                >
                  {isPlaying4 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>

            
 

 

 

 

            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef5}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Amit+Jha.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef5,
                      setIsPlaying5,
                      isPlaying5,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                        { ref: videoRef6, setPlaying: setIsPlaying6 },
                        { ref: videoRef7, setPlaying: setIsPlaying7 },
                        { ref: videoRef8, setPlaying: setIsPlaying8 },
                        { ref: videoRef9, setPlaying: setIsPlaying9 },
                      ]
                    )
                  }
                >
                  {isPlaying5 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef6}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Ashish.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef6,
                      setIsPlaying6,
                      isPlaying6,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                        { ref: videoRef5, setPlaying: setIsPlaying5 },
                        { ref: videoRef7, setPlaying: setIsPlaying7 },
                        { ref: videoRef8, setPlaying: setIsPlaying8 },
                        { ref: videoRef9, setPlaying: setIsPlaying9 },
                      ]
                    )
                  }
                >
                  {isPlaying6 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef7}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Lalit+Mohan.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef7,
                      setIsPlaying7,
                      isPlaying7,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                        { ref: videoRef5, setPlaying: setIsPlaying5 },
                        { ref: videoRef6, setPlaying: setIsPlaying6 },
                        { ref: videoRef8, setPlaying: setIsPlaying8 },
                        { ref: videoRef9, setPlaying: setIsPlaying9 },
                      ]
                    )
                  }
                >
                  {isPlaying7 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef9}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Anil+Kumar+Dhruv.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef9,
                      setIsPlaying9,
                      isPlaying9,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                        { ref: videoRef5, setPlaying: setIsPlaying5 },
                        { ref: videoRef6, setPlaying: setIsPlaying6 },
                        { ref: videoRef7, setPlaying: setIsPlaying7 },
                        { ref: videoRef8, setPlaying: setIsPlaying8 },
                      ]
                    )
                  }
                >
                  {isPlaying9 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="video-container">
                <video
                  ref={videoRef8}
                  src="https://stepmintbucket.s3.ap-south-1.amazonaws.com/Nahim.mp4"
                  className="video-player"
                  style={{ objectFit: "cover", objectPosition: "50%" }}
                />
                <button
                  className="play-pause-btn"
                  onClick={() =>
                    togglePlay(
                      videoRef8,
                      setIsPlaying8,
                      isPlaying8,
                      [
                        { ref: videoRef2, setPlaying: setIsPlaying2 },
                        { ref: videoRef3, setPlaying: setIsPlaying3 },
                        { ref: videoRef1, setPlaying: setIsPlaying1 },
                        { ref: videoRef4, setPlaying: setIsPlaying4 },
                        { ref: videoRef5, setPlaying: setIsPlaying5 },
                        { ref: videoRef6, setPlaying: setIsPlaying6 },
                        { ref: videoRef7, setPlaying: setIsPlaying7 },
                        { ref: videoRef9, setPlaying: setIsPlaying9 },
                      ]
                    )
                  }
                >
                  {isPlaying8 ? "❚❚" : "▶"}
                </button>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="d-flex gap-2 mt-3 justify-content-end align-items-center">
                    <button ref={prevRef} className="custom-swiper-button-prev">
                      <FaChevronLeft style={{ color: "white" }} />
                    </button>
          
                    <button ref={nextRef} className="custom-swiper-button-next">
                      <FaChevronRight style={{ color: "white" }} />
                    </button>
                  </div>
        </Container>
 <br />
 <br />
        <Container>
          <Row>
            <Col lg={6} className="d-flex align-items-center">
            <div>
            <h3 className="text-start mb-3 why-stepmint">
            Upcoming  <span className="why-stepmint-span">Fitness Features</span> 
            </h3>

            <ul className="new-home-s3-list">
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      Personalized health profile & goals
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />{" "}
                      BMI, BMR, fat %, muscle mass tracking
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      AI-powered workouts: HIIT, yoga, strength & more
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      Real-time wearable sync (Apple, Fitbit, Garmin, etc.)
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      Weekly/monthly progress dashboard
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      Optional AI Coach for next-level performance
                    </li>
                  </ul>
            </div>
            </Col>
            <Col lg={6}>
            <div>
              <img src="assets\images\newdesign\testimonial-new.png" className="img-fluid" alt="" />
            </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* SECTION 7 */}

      <DownloadSection />
      {/* SECTION 8 */}

      <Footer />
    </>
  );
};

export default NewTestimonials;
